import Vue from "vue";

import Cookies from "js-cookie";

import "@/components/mainCommon"

import Element from "element-ui";
import "./assets/styles/element-variables.scss";

import "@/assets/styles/index.scss"; // global css
import "@/assets/styles/ruoyi.scss"; // ruoyi css
import App from "./App";
import store from "./store";
import router from "./router";
import directive from "./directive"; // directive
import plugins from "./plugins"; // plugins
import { download } from "@/utils/request";
import { encrypt, decrypt } from "@/utils/jsencrypt";

import '@/utils/flexible' //缩放

import * as echarts from "echarts";
Vue.prototype.$echarts = echarts;

import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/css/swiper.css";
Vue.use(VueAwesomeSwiper /* { default options with global component } */);

import "./assets/icons"; // icon
// import './permission' // permission control
import { getDicts } from "@/api/system/dict/data";
import { getConfigKey } from "@/api/system/config";
import { judgeClient, isWeChatBrowser,getQueryParams, closeIos, closeAndroid } from '@/utils/index.js';
import { setToken } from '@/utils/auth'
import {
  parseTime,
  resetForm,
  addDateRange,
  selectDictLabel,
  selectDictLabels,
  handleTree,
} from "@/utils/ruoyi";
// 分页组件
import Pagination from "@/components/Pagination";
// 自定义表格工具组件
import RightToolbar from "@/components/RightToolbar";
// 富文本组件
import Editor from "@/components/Editor";
// 文件上传组件
import FileUpload from "@/components/FileUpload";
// 图片上传组件
import ImageUpload from "@/components/ImageUpload";
// 图片预览组件
import ImagePreview from "@/components/ImagePreview";
// 字典标签组件
import DictTag from "@/components/DictTag";
// 头部标签组件
import VueMeta from "vue-meta";
// 字典数据组件
import DictData from "@/components/DictData";

import Bridge from '@/components/dsbridge.js'

import Vant from 'vant';
import 'vant/lib/index.css'; // 引入 Vant 样式

Vue.use(Vant);


Vue.prototype.$bridge = Bridge

// 全局方法挂载
Vue.prototype.getDicts = getDicts;
Vue.prototype.getConfigKey = getConfigKey;
Vue.prototype.parseTime = parseTime;
Vue.prototype.resetForm = resetForm;
Vue.prototype.addDateRange = addDateRange;
Vue.prototype.selectDictLabel = selectDictLabel;
Vue.prototype.selectDictLabels = selectDictLabels;
Vue.prototype.download = download;
Vue.prototype.handleTree = handleTree;



// 外改
Vue.prototype.isPrivate = window.server.isPrivate;

Vue.prototype.isRoute = Vue.prototype.bodyCheck = Vue.prototype.apiUrl = window.location.origin;

if( process.env.NODE_ENV=="production" && !Vue.prototype.isPrivate ){
  Vue.prototype.imgUrl = `https://file.medmeta.com/`;
}else{
  Vue.prototype.imgUrl = `${window.location.origin}/file/`;
}
// 开发图片路径
// Vue.prototype.imgUrl = `https://192.168.3.113/file/`;
window.tokenEventObj = new Event("tokenEvent", {
        
});

 
function callAndroidFunctionWithParameter() {
    const that = this;
    Bridge.callmethod(
        "WebAction.getAppParams",
        { ceshi: "ceshi" },
        (res) => {
        }
    );
    //h5暴露方法给安卓调用，回传值给h5
    Bridge.registermethod("getU3dParams", (data) => {
        const jsonData = JSON.parse(data);
        const token = jsonData.token;
        setToken(token);
        window.dispatchEvent( tokenEventObj )
        
    });
}
function getAppParams() {
    try {
        //使用此方法,会报错,因此使用try-catch
        webkit.messageHandlers.getAppParams.postMessage(
        "js调用ios",
        (data) => {}
        );
    } catch (error) {
        console.log("WKWebView post message error: ", error);
    }
}
//app端返回值
function androidIos() {
    if (judgeClient() == "Android") {
      callAndroidFunctionWithParameter();
    } else {
      getAppParams();
    }       
}
    
//h5暴露方法给ios调用，回传值给h5
function getU3dParams(data) {
    const jsonData = JSON.parse(data);
    const token = jsonData.token;
    setToken(token);
    window.dispatchEvent( tokenEventObj )
}
console.log(">>>>>>>>>>", getQueryParams().token)
if( getQueryParams().token ){
    setToken( getQueryParams().token );
    localStorage.setItem("source", getQueryParams().source ? getQueryParams().source:"")
    window.dispatchEvent( tokenEventObj )
    
}else{
    window.getU3dParams = getU3dParams;
    androidIos();
}
   

Vue.prototype.isLocalDisk = decrypt(process.env.VUE_APP_IS_LOCAL_DISK);
Vue.prototype.appId = decrypt(process.env.VUE_APP_APPID);
Vue.prototype.apiKey = decrypt(process.env.VUE_APP_APIKEY);

// 全局组件挂载
Vue.component("DictTag", DictTag);
Vue.component("Pagination", Pagination);
Vue.component("RightToolbar", RightToolbar);
Vue.component("Editor", Editor);
Vue.component("FileUpload", FileUpload);
Vue.component("ImageUpload", ImageUpload);
Vue.component("ImagePreview", ImagePreview);

Vue.use(directive);
Vue.use(plugins);
Vue.use(VueMeta);
DictData.install();

/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online! ! !
 */

Vue.use(Element, {
  size: Cookies.get("size") || "medium", // set element-ui default size
});

Vue.config.productionTip = false;

new Vue({
  el: "#app",
  router,
  store,
  render: (h) => h(App),
});
